module.exports = __webpack_public_path__ + "img/cutlery-active.337f0b57.svg";